import { useState } from 'react';

export default function WhatsAppButton() {
  const [hovered, setHovered] = useState(false);

  const handleClick = () => {
    window.open('https://wa.me/34631611077?text=Hola%2C%20me%20gustar%C3%ADa%20obtener%20informaci%C3%B3n%20sobre%20importaci%C3%B3n%20de%20veh%C3%ADculos.', '_blank');
  };

  return (
    <div className="fixed bottom-8 right-8 z-50 flex items-center gap-3">
      {/* Tooltip */}
      <div
        className={`transition-all duration-300 ${
          hovered ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-4 pointer-events-none'
        }`}
      >
        <div className="glass-card rounded-xl px-4 py-2 whitespace-nowrap">
          <p className="text-white text-xs font-medium">¡Escríbenos ahora!</p>
          <p className="text-white/40 text-xs">Respuesta inmediata</p>
        </div>
      </div>

      {/* Button */}
      <button
        onClick={handleClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        className="w-16 h-16 flex items-center justify-center bg-green-500 hover:bg-green-400 rounded-full shadow-lg hover:scale-110 transition-all duration-300 cursor-pointer animate-pulse-glow"
        style={{ boxShadow: '0 0 20px rgba(34, 197, 94, 0.4), 0 0 40px rgba(34, 197, 94, 0.2)' }}
        aria-label="Contactar por WhatsApp"
      >
        <i className="ri-whatsapp-line text-white text-3xl" />
      </button>
    </div>
  );
}